import type { Task } from "../tasks";

export const tasksFixtures: Task[] = [
  {
    id: "task-documento-anomalo-alfa",
    titolo: "Verificare documento anomalo",
    descrizione: "Controllare il documento segnalato e confermare se ci sono elementi da approfondire.",
    responsabile: "Raffaele Battaglini",
    stato: "Da fare",
    priorita: "Urgente",
    scadenza: "18 ott 2026",
    azienda: "Alfa S.r.l.",
    processo: "Antifrode",
    origine: "Generato dal processo Antifrode",
  },
];
